export { RadioGroup as default } from '@material-ui/core';
